import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
    display:flex;
    flex-direction:column;
    height:100vh;
    align-items:center;
    justify-content:space-around;

 
    
`;


export const ContainerButton = styled.button`
    background-color:${theme.colors.light};
    font-size:28px;
    font-weight:bold;
    color:${theme.colors.dark};
    display:flex;
    align-items:center;
    justify-content:space-around;
    padding:12px;
    border-radius:0.25rem ;
    width:100vw;
    max-width:400px;
    &:hover{
        opacity:0.7;
    }

`;


export const Logo = styled.img`
    width:100px;
`;